// Boat render (M16.2): a pooled flat open-top hull per boat, positioned at the
// water surface the sim floats it to and yawed to its heading. Client-only (ENG-1);
// the sim owns the buoyancy + paddle physics. A proper planked model is deferred.
import * as THREE from 'three';
import type { Boat } from '../../sim/entities/boat';

const HULL = 0x8a6a3a;      // oak
const CHEST_HULL = 0x9a7a2a; // amber-tinted for a chest boat

export class BoatRenderer {
  private readonly group = new THREE.Group();
  private readonly meshes = new Map<number, THREE.Mesh>();
  private readonly geo = new THREE.BoxGeometry(1.4, 0.4, 1.4);

  constructor(scene: THREE.Scene) {
    scene.add(this.group);
  }

  update(boats: readonly Boat[]): void {
    const seen = new Set<number>();
    for (const b of boats) {
      seen.add(b.id);
      let m = this.meshes.get(b.id);
      if (!m) {
        const color = b.kind === 'chest_boat' ? CHEST_HULL : HULL;
        m = new THREE.Mesh(this.geo, new THREE.MeshLambertMaterial({ color }));
        this.meshes.set(b.id, m);
        this.group.add(m);
      }
      m.position.set(b.x, b.y + 0.2, b.z);
      m.rotation.y = b.yaw;
    }
    for (const [id, m] of this.meshes) {
      if (seen.has(id)) continue;
      this.group.remove(m);
      (m.material as THREE.Material).dispose();
      this.meshes.delete(id);
    }
  }

  clear(): void {
    for (const m of this.meshes.values()) {
      this.group.remove(m);
      (m.material as THREE.Material).dispose();
    }
    this.meshes.clear();
  }
}
